import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import about1 from '../../images/aboutimg.svg';
import about2 from '../../images/about/about_image_11.webp'
import about3 from '../../images/about/about_image_10.webp'

const About = (props) => {

    const [isOpen, setOpen] = useState(false)

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className="about_section section_space">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                          <img src={about1} alt="Techco - About" />
                    </div>
                    <div className="col-lg-6">
                        <h1>Welcome to Ease My Hotel</h1>
                        <h4 style={{marginBottom:'30px', marginTop:'20px'}}>Designed for Hotels, Resorts & Vacation Rentals </h4>
                        <p>No more juggling spreadsheets or switching between systems. Our platform is purpose-built for:</p>
                        <ul className="ordered_list about_list">
                            <li>Hotel chains and independent hotels</li>
                            <li>Beachfront and luxury resorts</li>
                            <li>Airbnb, homestays, and vacation rentals</li>
                        </ul>
                        <p>If you run a property, we make running it easier.</p>

                        <Link className="btn" to="/pricing">
                            <span className="btn_label" data-text="Try for Free">Try for Free</span>
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About;